export default {
    title_list: 'Companies requests',
    title_page: 'Company request',
    title_create_page: 'Create a company request',
    title_edit_page: 'Change company request',

    filter: {
        labels: {
            user_id: 'Member',
            company_id: 'Company',
            status_id: 'Status',
            note: 'Note',
        }
    },

    table: {
        labels: {
            id: 'ID',
            user_id: 'Member',
            company_id: 'Company',
            status_id: 'Status',
            note: 'Note',
            created_at: 'Date',
        }
    },

    buttons: {

    },

    form: {
        user_id: 'Member',
        company_id: 'Company',
        status_id: 'Status',
        note: 'Note',
    },
}
